import request from '@/utils/api/request';

export const state = () => ({
  // Global configuration
  currency: '€',
  units: [],
  unitsOpened: null,
  supportPhone: '',

  currencies: {},
  currencySymbols: {},

  languages: [],
  roles: {},
  tenderOfferVersionStatuses: {},
  tenderOfferStatuses: {},
  tenderStatuses: {},

  project_states: {},

  isTableLoading: false,

  currentProject: null,

  // update whole projects on data inside project change
  projectUpdate: null,

  sidebarOpen: true,
});

export const mutations = {
  changeField(state, { key, value }) {
    state[key] = value;
  },
};

export const actions = {
  changeSaved({ commit }, value) {
    commit('changeField', { key: 'currency', value });
  },
  changeProjectUpdate({ commit }, value) {
    commit('changeField', { key: 'projectUpdate', value });
  },
  changeGlobalUnits({ commit }) {
    commit('changeField', { key: 'unitsOpened', value: new Date().toString() });
  },
  openSidebar({ commit }, value) {
    commit('changeField', { key: 'sidebarOpen', value });
  },
  toggleTableLoading({ commit }, value) {
    commit('changeField', { key: 'isTableLoading', value: value });
  },
  changeCurrentProject({ commit }, value) {
    commit('changeField', { key: 'currentProject', value });
  },
  async fetchProperties({ commit }) {
    try {
      const { data } = await request.get('/properties/');
      commit('changeField', { key: 'roles', value: data.roles });
      commit('changeField', {
        key: 'tenderOfferVersionStatuses',
        value: data.tender_offer_version_statuses,
      });
      commit('changeField', { key: 'tenderOfferStatuses', value: data.tender_offer_statuses });
      commit('changeField', { key: 'languages', value: data.languages });
      commit('changeField', { key: 'project_states', value: data.project_states });
      commit('changeField', { key: 'tenderStatuses', value: data.tender_statuses });
      commit('changeField', { key: 'units', value: data.units });
      commit('changeField', { key: 'supportPhone', value: data.support_phone });
      commit('changeField', { key: 'currencies', value: data.currencies });
      commit('changeField', { key: 'currencySymbols', value: data.currency_symbols });
    } catch (e) {
      console.error(e);
    }
  },
};

export const getters = {
  languagesList: (state) => {
    const languages = Object.keys(state.languages)?.map((key) => ({
      value: key,
      text: state.languages[key],
    }));
    return languages || [];
  },
  // USD ($), EUR (€)
  currencyWithSymbol: (state) => (currencyKey) => {
    if (!currencyKey) {
      return '';
    }
    const currencyTitle = currencyKey.toUpperCase();
    const currencySymbol = state.currencySymbols[currencyKey];
    const currencySymbolText = `(${currencySymbol})`;
    return `${currencyTitle} ${currencySymbol ? currencySymbolText : ''}`;
  },
  currencySymbol: (state) => (currencyKey) => {
    if (!currencyKey) {
      return '';
    }
    return state.currencySymbols?.[currencyKey];
  },
  currencySelectItems: (state, getters) => {
    return Object.entries(state.currencies).map(([value]) => {
      return {
        value,
        text: getters.currencyWithSymbol(value),
      };
    });
  },
};

export default { namespaced: true, state, mutations, actions, getters };
